var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#141E30",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3881 45H45.0616C42.2661 45 40 47.2662 40 50.0616V75.2304C40 78.0038 42.2309 80.2551 44.9959 80.2902V80.2918L46.4062 81.0899H54.4531L56.3411 80.292H75.3876C78.1831 80.292 80.4491 78.0259 80.4491 75.2304V50.0616C80.4491 47.2664 78.1832 45.0003 75.3881 45Z",
    fill: "#C5DBF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0872 45H74.938C77.7335 45 79.9995 47.2661 79.9995 50.0616V75.2304C79.9995 78.0259 77.7335 80.292 74.938 80.292H85.0872C87.8827 80.292 90.1487 78.0259 90.1487 75.2304V50.0616C90.1487 47.2662 87.8827 45 85.0872 45Z",
    fill: "#C5DBF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9956 92.0496C44.9956 92.7871 45.9264 93.1104 46.3836 92.5316L55.4434 81.062C55.8275 80.5757 56.4131 80.292 57.0328 80.292H44.9956V92.0496Z",
    fill: "#C5DBF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0877 45H74.9385C77.7339 45 80 47.2661 80 50.0616V75.2304C80 78.0259 77.7339 80.292 74.9385 80.292H85.0877C87.8831 80.292 90.1492 78.0259 90.1492 75.2304V50.0616C90.1492 47.2662 87.8831 45 85.0877 45Z",
    fill: "#2B59C3",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 92.0496C44.9961 92.7871 45.9269 93.1104 46.3841 92.5316L55.4439 81.062C55.8279 80.5757 56.4136 80.292 57.0333 80.292H44.9961V92.0496Z",
    fill: "#2B59C3",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.26 101.788L104.078 104.09C104.39 104.078 104.643 103.841 104.684 103.531C104.866 102.148 105.748 100.958 107.038 100.352C109.013 99.4227 110.38 97.4158 110.38 95.089V66.1768C110.38 62.9657 107.777 60.3625 104.565 60.3625H68.2065C64.9952 60.3625 62.3921 62.9656 62.3921 66.1768V95.089C62.3921 98.3002 64.9952 100.903 68.2065 100.903H100.433C101.146 100.903 101.818 101.229 102.26 101.788Z",
    fill: "#D0EACC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.185 60.3625H104.002C107.213 60.3625 109.816 62.9656 109.816 66.1768V95.089C109.816 97.4158 108.449 99.4227 106.475 100.352C105.02 101.036 104.077 102.482 104.077 104.09L112.666 114.963C113.192 115.628 114.261 115.257 114.261 114.41V100.901C117.437 100.861 120 98.2747 120 95.0888V66.1768C120 62.9656 117.397 60.3625 114.185 60.3625Z",
    fill: "#D0EACC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.185 60.3625H104.002C107.213 60.3625 109.816 62.9656 109.816 66.1769V95.089C109.816 97.4159 108.449 99.4227 106.475 100.352C105.02 101.036 104.077 102.482 104.077 104.09L112.666 114.963C113.192 115.628 114.261 115.257 114.261 114.41V100.901C117.437 100.861 120 98.2748 120 95.0888V66.1769C120 62.9656 117.397 60.3625 114.185 60.3625Z",
    fill: "#2B59C3",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.35 72.1277H72.0407C71.374 72.1277 70.8335 71.5873 70.8335 70.9206C70.8335 70.2538 71.374 69.7134 72.0407 69.7134H110.35C111.017 69.7134 111.558 70.2538 111.558 70.9206C111.558 71.5873 111.017 72.1277 110.35 72.1277Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.35 81.3565H72.0407C71.374 81.3565 70.8335 80.816 70.8335 80.1493C70.8335 79.4826 71.374 78.9421 72.0407 78.9421H110.35C111.017 78.9421 111.558 79.4826 111.558 80.1493C111.558 80.8159 111.017 81.3565 110.35 81.3565Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.35 90.5851H72.0407C71.374 90.5851 70.8335 90.0446 70.8335 89.3779C70.8335 88.7112 71.374 88.1707 72.0407 88.1707H110.35C111.017 88.1707 111.558 88.7112 111.558 89.3779C111.558 90.0446 111.017 90.5851 110.35 90.5851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoComments);
export default __webpack_public_path__ + "static/media/no-comments.6bb4b409.svg";
export { ForwardRef as ReactComponent };